export default __webpack_public_path__ + "ada92854544900c7cb81a3b0beb0f674.svg";